import { customersActions, customersSelectors, customersTypes } from 'app-components/flux/customers';
import { rootUiTypes } from 'app-components/flux/root-ui';
import { rootUiActions } from 'app-components/flux/root-ui';
import {
  DIALOG_TYPE as CONFIRMATION_DIALOG_TYPE,
  mkConfirmationDialogProps,
} from 'components/Dialogs/ConfirmationDialog';
import { useAppDispatch, useAppStore } from 'hooks/redux';
import { Map as ImMap } from 'immutable';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useCustomerActions = () => {
  const store = useAppStore();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const archiveCustomer = useCallback(
    (customerId?: string, goBack?: boolean) => {
      const customer = customerId ? customersSelectors.getCustomerById(store.getState(), customerId) : undefined;
      if (customer) {
        dispatch(
          rootUiActions.createDialog(
            rootUiTypes.mkRootUiData({
              id: 'archive-customer',
              type: CONFIRMATION_DIALOG_TYPE,
              props: ImMap(
                mkConfirmationDialogProps({
                  title: 'Archive Client',
                  content:
                    'Are you sure you want to archive this client? You will no longer be able to make changes to any associated items and invoices.',
                  confirmLabel: 'Archive Client',
                  confirmButtonVariant: 'delete',
                  denyLabel: 'Cancel',
                  confirmAction: () => {
                    dispatch(customersActions.updateCustomer(customer.set('isArchived', true)));
                    goBack && navigate('/clients');
                  },
                }),
              ),
            }),
          ),
        );
      }
    },
    [dispatch, navigate, store],
  );

  // Should be used behind dev only
  const deleteCustomer = useCallback(
    (customerId: string) => {
      dispatch(
        rootUiActions.createDialog(
          rootUiTypes.mkRootUiData({
            id: 'delete-client',
            type: CONFIRMATION_DIALOG_TYPE,
            allowNesting: true,
            props: ImMap(
              mkConfirmationDialogProps({
                title: 'Delete client (dev only)',
                content: 'Are you sure you want to delete this client?',
                confirmLabel: 'Confirm',
                denyLabel: 'Cancel',
                confirmAction: () => {
                  dispatch(customersActions.deleteCustomer(customersTypes.mkCustomer({ id: customerId })));
                },
              }),
            ),
          }),
        ),
      );
    },
    [dispatch],
  );

  const unarchiveCustomer = useCallback(
    (customerId: string) => {
      const customer = customerId ? customersSelectors.getCustomerById(store.getState(), customerId) : undefined;
      if (customer) {
        dispatch(customersActions.updateCustomer(customer.set('isArchived', false)));
      }
    },
    [dispatch, store],
  );

  return { archiveCustomer, deleteCustomer, unarchiveCustomer };
};

export default useCustomerActions;
